import Message, { Timer } from '@talkdesk/cobalt-react-message'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import { Text } from '@talkdesk/cobalt-react-typography'
import styles from './ToastError.module.css'

const DELAY_SECS = 4

const ToastError = ({ title, onDismiss }) => (
  <Message
    id='toast-error'
    variation='error'
    type='floating'
    className={styles.toaster}
  >
    <Flex padding='3' width='100%' direction='column'>
      <Flex width='100%' alignY='center' alignX='space-between'>
        <Flex gap={4} padding='1' alignY='center'>
          <IconWithProvider name='error' size='tiny' />
          <Flex direction='column'>
            <Text weight='medium'>{title}</Text>
          </Flex>
        </Flex>
        <IconWithProvider
          name='close'
          data-id='close-button-toaster'
          onClick={onDismiss}
        />
      </Flex>
    </Flex>
    <Timer active duration={DELAY_SECS} elapsed={0} />
  </Message>
)

export default ToastError
